import React, { useState, useEffect } from 'react';
import './SizeTypeSelector.scss';
import { useGlobalStore } from '@stores/globalStore';

const SizeTypeSelector = ({ setTog, tog, isburger, setShowModal }) => {
    const { setSizeType, sizeType} = useGlobalStore()
   return (
    <> <div className="label">Area Size</div>
        <div className="sq-bx">
            <button
                className={sizeType === 'mToFt' ? 'active' : ''}
                onClick={() => {
                    setSizeType('mToFt');
                    localStorage.setItem('sizeType', 'mToFt');
                    setTog(!tog);
                    isburger ? setShowModal(false) : null
                }}
            >
                SQ FT
            </button>
            <button
                className={sizeType === 'ftToM' ? 'active' : ''}
                onClick={() => {
                    setSizeType('ftToM');
                    localStorage.setItem('sizeType', 'ftToM');
                    setTog(!tog);
                    isburger ? setShowModal(false) : null
                }}
            >
                SQ M
            </button>
        </div>
        </>
    );
};

export default SizeTypeSelector;
